import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const CustomWebsites = () => {
  const pageData = {
    category: "CUSTOM WEBSITES",
    title: "Custom Website Development",
    description: "Build blazing-fast, fully customized web applications with modern frameworks like React and Next.js. Our custom development delivers unmatched performance, scalability, and flexibility for businesses with unique requirements.",

    features: [
      {
        title: "React & Next.js Development",
        description: "Leverage cutting-edge JavaScript frameworks for lightning-fast, SEO-friendly single-page applications and server-rendered sites."
      },
      {
        title: "Headless CMS Integration",
        description: "Connect your site to powerful headless CMS platforms like Contentful, Sanity, or Strapi for flexible content management."
      },
      {
        title: "Custom API Development",
        description: "Build robust REST or GraphQL APIs to connect your website with third-party services, databases, and internal systems."
      },
      {
        title: "Progressive Web Apps (PWA)",
        description: "Transform your website into an app-like experience with offline capabilities, push notifications, and home screen installation."
      },
      {
        title: "E-Commerce Solutions",
        description: "Develop custom e-commerce platforms with Shopify Hydrogen, custom checkout flows, and advanced product management."
      },
      {
        title: "Performance Optimization",
        description: "Achieve 95+ PageSpeed scores with code splitting, lazy loading, image optimization, and efficient caching strategies."
      }
    ],

    benefits: [
      {
        title: "Complete Customization",
        description: "No limitations or bloated code. Build exactly what you need with full control over every feature and design element."
      },
      {
        title: "Lightning-Fast Speed",
        description: "Optimized code and modern frameworks deliver sub-second load times that boost conversions and SEO rankings."
      },
      {
        title: "Infinite Scalability",
        description: "Architecture designed to handle growth from startup to enterprise without performance degradation."
      },
      {
        title: "Future-Proof Technology",
        description: "Built with modern, well-supported frameworks that ensure your site stays current and maintainable for years."
      }
    ],

    process: [
      {
        title: "Requirements & Architecture",
        description: "Define technical requirements, user flows, database schema, API needs, and select the optimal tech stack."
      },
      {
        title: "Design & Prototyping",
        description: "Create high-fidelity designs, interactive prototypes, and component libraries that align with your brand."
      },
      {
        title: "Development & Integration",
        description: "Build your application with clean, modular code, integrate third-party services, and implement rigorous testing."
      },
      {
        title: "Deployment & Optimization",
        description: "Launch on enterprise-grade infrastructure with CDN, monitoring, and continuous performance optimization."
      }
    ],

    relatedServices: [
      {
        title: "WordPress Development",
        description: "Flexible CMS-based websites for easier content management",
        link: "/services/web-development/wordpress"
      },
      {
        title: "Shopify Development",
        description: "Powerful e-commerce stores with custom themes",
        link: "/services/web-development/shopify"
      },
      {
        title: "Technical SEO",
        description: "Optimize your custom site for search engine performance",
        link: "/services/seo/technical-seo"
      }
    ],

    ctaText: "Ready to build a custom web application that scales with your business? Let's discuss your project requirements.",
    ctaLink: "/contact",
    parentLink: "/services/web-development",
    parentTitle: "Web Development"
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Custom Websites Services" 
                description="Learn more about our Custom Websites services to grow your business online with Digi Network." 
                canonical="/web-development/custom-websites" 
            />

    </>
  );
};

export default CustomWebsites;
